import { initializeApp, getApps, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'
import { getFirestore, type Firestore } from 'firebase/firestore'
import { getFunctions, type Functions } from 'firebase/functions'

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

/** Región de las Cloud Functions (debe coincidir con functions/src/http.ts). */
const REGION = 'us-central1'

/** true si hay proyecto configurado; si no, el widget corre en modo mock. */
export const hasFirebase = Boolean(config.projectId && config.apiKey)

let app: FirebaseApp | undefined

export function getFirebase(): {
  app: FirebaseApp
  auth: Auth
  db: Firestore
  functions: Functions
} | null {
  if (!hasFirebase) return null
  if (!app) {
    app = getApps().length ? getApps()[0]! : initializeApp(config, 'tc-widget')
  }
  return { app, auth: getAuth(app), db: getFirestore(app), functions: getFunctions(app, REGION) }
}
